module.exports = __webpack_public_path__ + "img/pro_three_5.1b68a8fc.jpg";